import { CompanyMatchUploadResponse } from "../../../types/companyMatch";

export enum FileUploadFilterMode {
  DEFINE_WHITESPACE_FILTER = "DEFINE_WHITESPACE_FILTER",
  UPLOAD_ACCOUNT_FILTER = "UPLOAD_ACCOUNT_FILTER",
  ICP_CUSTOMER_LIST = "ICP_CUSTOMER_LIST",
}

export interface CustomerUploadSectionProps {
  matchData: CompanyMatchUploadResponse | null;
  onUpdateMatchData: (data: CompanyMatchUploadResponse) => void;
  mode?: FileUploadFilterMode;
  id?: string;
}

/**
 * Upload state for customer upload component
 */
export type UploadState =
  | "idle"
  | "success"
  | "error"
  | "uploading"
  | "processing";

export enum UPLOAD_STATE {
  IDLE = "idle",
  SUCCESS = "success",
  ERROR = "error",
  UPLOADING = "uploading",
  PROCESSING = "processing",
}
